module.exports = __webpack_public_path__ + "static/media/Chresta Pic.e2966ca9.jpg";